import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Input, Button, Typography, Message, Space, Link } from "@arco-design/web-react";
import { registerLocal, loginLocal } from "./Api/localAuth";

const { Title, Text } = Typography;

// Dev-only local auth page (backend LOCAL_AUTH). Mounted at /register and
// /local-login; lets a developer create an account / log in without Auth0.
export default function LocalAuth({ initialMode = "login" }) {
  const [mode, setMode] = useState(initialMode); // "login" | "register"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [orgName, setOrgName] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const isRegister = mode === "register";

  const submit = async () => {
    if (!email || !password) {
      Message.warning("Email and password are required");
      return;
    }
    setBusy(true);
    try {
      if (isRegister) {
        await registerLocal({ email, password, organizationName: orgName });
        Message.success("Account created — you're logged in");
      } else {
        await loginLocal({ email, password });
        Message.success("Logged in");
      }
      navigate("/home");
    } catch (e) {
      Message.error(e.message || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "80px auto", padding: "0 16px" }}>
      <Card>
        <Title heading={4} style={{ marginTop: 0 }}>
          {isRegister ? "Create a local account" : "Log in (local)"}
        </Title>
        <Text type="secondary">Dev-only auth — bypasses Auth0 for local testing.</Text>

        <Space direction="vertical" size="medium" style={{ width: "100%", marginTop: 20 }}>
          <Input
            placeholder="Email"
            value={email}
            onChange={setEmail}
            onPressEnter={submit}
          />
          <Input.Password
            placeholder="Password"
            value={password}
            onChange={setPassword}
            onPressEnter={submit}
          />
          {isRegister && (
            <Input
              placeholder="Organization name (optional)"
              value={orgName}
              onChange={setOrgName}
              onPressEnter={submit}
            />
          )}
          <Button type="primary" long loading={busy} onClick={submit}>
            {isRegister ? "Create account" : "Log in"}
          </Button>
        </Space>

        <div style={{ marginTop: 16 }}>
          {isRegister ? (
            <Text type="secondary">
              Already have an account?{" "}
              <Link onClick={() => setMode("login")}>Log in</Link>
            </Text>
          ) : (
            <Text type="secondary">
              Need an account?{" "}
              <Link onClick={() => setMode("register")}>Register</Link>
            </Text>
          )}
        </div>
      </Card>
    </div>
  );
}
